export const SINGLE_OUTCOME = 1;
export const MULTI_OUTCOME = 2;
export const WIDE_SINGLE_OUTCOME = 3;
export const WIDE_MULTI_OUTCOME = 4;
export const TOTAL = 5;
export const TENNIS_GAME = 6;
export const SOCCER_MATCH_CORRECT_SCORE = 7;
export const BASKETBALL_TOTAL_UNDER = 8;
export const BASKETBALL_TOTAL_OVER = 9;
export const NAMED_OUTCOME_SLOT = 10;



// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/constants/SlotFamilyType.js